import api from './api';

const concesionariaWarehouseConfigService = {
  list() {
    return api
      .get('/produccion-concesionaria/configuraciones/almacenes-producto-terminado')
      .then((r) => r.data);
  },
  create(principalWarehouseId) {
    return api
      .post('/produccion-concesionaria/configuraciones/almacenes-producto-terminado', {
        principal_warehouse_id: Number(principalWarehouseId),
      })
      .then((r) => r.data);
  },
  remove(id) {
    return api
      .delete(`/produccion-concesionaria/configuraciones/almacenes-producto-terminado/${id}`)
      .then((r) => r.data);
  },
};

export default concesionariaWarehouseConfigService;

